export const ADMIN_GET_WIDGETS = 'ADMIN_GET_WIDGETS'
export const ADMIN_USER_REPORT = 'ADMIN_USER_REPORT'
export const ADMIN_ORDER_REPORT = 'ADMIN_ORDER_REPORT'
